// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/EuclidCircularB/EuclidCircularB-Bold.eot", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Euclid Circular B";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype");
  font-display: swap;
}
@font-face {
  font-family: "Euclid Circular B";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype");
  font-display: swap;
}
@font-face {
  font-family: "Euclid Circular B";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype");
  font-display: swap;
}
@font-face {
  font-family: "Euclid Circular B";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype");
  font-display: swap;
}
:root {
  --default-font: "Euclid Circular B";
  --accent-color: #2DBE64;
  --accent-color-rgb: 45, 190, 100;
  --accent-text-color: #fff;
  --text-color: #151B26;
  --white: #ffffff;
  --white-550: #F2F2F2;
  --gray-20: #F0F1F5;
  --grey-25: #F9FAFB;
  --gray-100: #E0E7EB;
  --gray-200: #C2CFD6;
  --gray-180: #47536B;
  --gray-500: #668899;
  --gray-950: #101618;
  --error: #fa5959;
  --orange-500: #F2A60F;
  --black: #101010;
  --black-900: #000000;
  --background: #F4F5FF;
  --grey-50: #FCFCFC;
  --grey-90: #F9F9F9;
  --grey-250: #E8EBF0;
  --grey-300: #D2D2D2;
  --blue: #6420FF;
  --blue-300: #5c8cdf;
  --blue-500: #177FD2;
  --red: #FF6864;
  --green-300: #B6DF73;
  --green: #7CBA00;
  --yellow: #FFB803;
  --violet: #A700FF;
  --overlay-color: #00000099;
  --fz-xs: 10px;
  --fz-sm: 12px;
  --fz-md: 14px;
  --fz-lg: 16px;
  --lh-xs: 12px;
  --lh-sm: 14px;
  --lh-md: 16px;
  --lh-lg: 18px;
  --lh-xlg: 20px;
  --header-height: 48px;
  --grid-spacing: 24px;
  --container: 1208px;
  --aside-width: 260px;
  --aside-width-md: 320px;
  --modal-aside-width: 260px;
  --modal-aside-width-lg: 360px;
  --modal-chats-body-width: 520px;
  --modal-chats-info-width: 224px;
  --modal-footer-height: 48px;
  --transition: 0.2s ease;
}

@media (min-width: 640px) {
  :root {
    --header-height: 64px;
  }
}
[data-whatintent=touch] *:focus,
[data-whatintent=mouse] *:focus {
  outline: none;
}

* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

*::before,
*::after {
  box-sizing: inherit;
}

button {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
}

svg {
  fill: currentColor;
}
svg.stroke-icon {
  fill: none;
  stroke: currentColor;
}
a svg, button svg {
  pointer-events: none;
}
svg:not(:root) {
  overflow: hidden;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: currentColor;
  margin: 0;
  padding: 0;
}

h2 {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
}

h3 {
  font-size: 20px;
  line-height: 23px;
  font-weight: 500;
}

h4 {
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
}

h5 {
  font-size: 14px;
  line-height: normal;
  font-weight: 600;
}

h6 {
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
}

hr {
  margin: 10px 0;
}

ul, p {
  padding: 0;
  margin: 0;
}

blockquote {
  font-style: italic;
  margin: 0 0 0 20px;
}

fieldset {
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
}

input,
textarea {
  font-family: inherit;
  border: none;
  outline: none;
}

.skeletonImage::after, .selectSkeleton::after, .selectBack::after,
.skeletonBlock::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(56.25% 434.37% at 53.12% 53.13%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  animation: skeletonProgress 1.2s ease-in-out infinite;
}

.selectBack,
.skeletonBlock {
  background: #EAEAEA;
  overflow: hidden;
  position: relative;
}
.selectSkeleton {
  min-height: 40px;
  cursor: pointer;
  background: #EAEAEA;
  border-radius: 8px 0 0 8px;
  box-shadow: none;
  width: 130px;
  overflow: hidden;
  position: relative;
}
.selectSkeleton_bottom {
  width: 28px;
}

.skeletonImage {
  background: var(--color-border);
  overflow: hidden;
}
.skeletonImage * {
  position: relative;
  z-index: 2;
}
.skeletonImage::after {
  z-index: 1;
}

@keyframes skeletonProgress {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
.custom-select .custom-select__control {
  cursor: pointer;
  box-shadow: none;
}
.custom-select .custom-select__control--is-focused, .custom-select .custom-select__control:hover {
  border-color: var(--accent-color);
}
.custom-select .custom-select__menu-list {
  padding-top: 0;
  padding-bottom: 0;
}
.custom-select .custom-select__option {
  cursor: pointer;
}
.custom-select .custom-select__option:active, .custom-select .custom-select__option--is-focused {
  background-color: rgba(var(--accent-color-rgb), 0.1);
}
.custom-select .custom-select__option--is-selected {
  background-color: var(--accent-color);
  color: var(--accent-text-color);
}
.custom-select .custom-select__option--is-selected:active {
  background-color: var(--accent-color);
  color: var(--accent-text-color);
}

:root {
  --app-height: 100vh;
  --app-height-dvh: 100dvh;
}

body > iframe {
  display: none;
}

html,
body {
  padding: 0;
  margin: 0;
  font-family: var(--default-font), sans-serif;
  font-size: 14px;
  line-height: 100%;
  font-weight: 400;
  color: var(--text-color);
  scroll-behavior: smooth;
  background: #fafafa;
  --webkit-font-smoothing: antialiased;
}
@media (min-width: 1200px) {
  html,
  body {
    background: #F6F7F8;
  }
}
html.noscroll,
body.noscroll {
  overflow: hidden;
}

a {
  color: inherit;
  text-decoration: none;
}

.wrapper {
  min-height: 100vh;
  min-height: var(--app-height);
  min-height: var(--app-height-dvh);
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
}
@media (min-width: 640px) {
  .wrapper {
    padding: 36px 24px 20px;
  }
}
@media (min-width: 1200px) {
  .wrapper {
    overflow: initial;
    padding: 0;
  }
}
.wrapper .header,
.wrapper .footer {
  flex: 0 0 auto;
}
.wrapper main {
  display: flex;
  position: relative;
  flex: 1 0 auto;
}
@media (max-width: 1200px) {
  .wrapper main {
    padding-bottom: 62px;
  }
}

.header,
.footer,
main {
  width: 100%;
  max-width: 800px;
}
@media (min-width: 1200px) {
  .header,
  .footer,
  main {
    max-width: none;
  }
}

.header,
main {
  margin: 0 auto;
}

@media (min-width: 1200px) {
  main {
    display: flex;
    grid-gap: 0 40px;
    max-width: var(--container);
    padding: 25px var(--grid-spacing);
  }
}

@media (min-width: 1200px) {
  .main-aside {
    flex-shrink: 0;
    width: var(--aside-width);
  }
}
.main-aside__inner {
  position: sticky;
  top: calc(var(--header-height) + 25px);
  width: inherit;
}

@media (min-width: 1200px) {
  .main--md .main-aside {
    width: var(--aside-width-md);
  }
}
@media (min-width: 1200px) {
  .main--md .main-content {
    max-width: calc(100% - var(--aside-width-md) - 40px);
  }
}

.main-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (min-width: 1200px) {
  .main-content {
    display: block;
    flex: 1 1;
    max-width: calc(100% - var(--aside-width) - 40px);
  }
}
@media (min-width: 1200px) {
  .main-content--full {
    max-width: none;
  }
}

.footer {
  position: relative;
  z-index: 2;
  margin: auto auto 66px;
}
@media (min-width: 1200px) {
  .footer {
    margin: auto auto 0;
  }
}

.lang-modal {
  padding: 12px;
  align-items: flex-end;
}
.lang-modal .modal__inner {
  margin-bottom: 0;
  max-width: none;
}
.lang-modal .modal__inner .modal-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.lang-modal .modal__inner .modal-title {
  line-height: 25px;
}
.lang-modal .modal__inner .modal-desc {
  font-size: 12px;
  line-height: 13.5px;
  color: #7A808B;
}
.lang-modal .modal__inner .modal__close-btn {
  top: 16px;
  right: 16px;
}

.container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1440px;
  }
}

.btn {
  height: 44px;
  width: 100%;
  border-radius: 12px;
  background: linear-gradient(90deg, #457cfa 0%, #984cf4 100%);
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  position: relative;
}
.btn:disabled {
  opacity: 0.8;
  cursor: default;
}
.btn_grey {
  background: #eee;
  color: #000;
}
.btn_orange {
  background: linear-gradient(90deg, #fa7b45 0%, #f44c4c 100%);
}
.btn-loader {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  animation: loader 2s infinite linear;
  transform-origin: center;
  width: 24px;
  height: 24px;
}
@keyframes loader {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  0% {
    transform: translateY(-50%) rotate(360deg);
  }
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
}
@media (hover: hover) {
  .btn:hover {
    opacity: 0.8;
  }
}
@media (min-width: 640px) {
  .btn {
    font-size: 20px;
    height: 76px;
  }
}

.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  color: #000;
}
@media (min-width: 640px) {
  .modal-title {
    font-size: 32px;
    line-height: 42px;
  }
}
@media (min-width: 1200px) {
  .modal-title {
    font-size: 24px;
    line-height: 27px;
    font-weight: 500;
  }
}

.modal-text {
  margin-top: 8px;
  letter-spacing: -0.28px;
  line-height: 144%;
}
@media (min-width: 640px) {
  .modal-text {
    letter-spacing: -0.4px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .modal-text {
    font-size: var(--fz-md);
    line-height: var(--lh-md);
    letter-spacing: normal;
    text-align: center;
  }
}
.modal-text__link {
  color: #1d8ae2;
  text-decoration: underline;
}

.modal-input {
  margin-top: 32px;
}
@media (min-width: 1200px) {
  .modal-input {
    margin-top: 24px;
  }
}
.modal-input .input-label {
  line-height: 144%;
  letter-spacing: -0.28px;
  margin-bottom: 8px;
}
@media (min-width: 1200px) {
  .modal-input .input-label {
    letter-spacing: normal;
    line-height: var(--lh-md);
  }
}
.modal-input input,
.modal-input textarea {
  border-radius: 12px;
  border: 1px solid #e8ecee;
  background: #fff;
  padding: 13px 16px;
  height: 52px;
  width: 100%;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  resize: none;
}
.modal-input input[disabled],
.modal-input textarea[disabled] {
  background: #f5f5f5;
}
.modal-input textarea {
  overflow: auto;
}
.modal-input_cancel {
  margin-top: 16px;
}
.modal-input_cancel input,
.modal-input_cancel textarea {
  font-size: 16px;
  font-weight: 400;
}
.modal-input.error input {
  border-color: #f2200d;
}
.modal-input.error .error-text {
  opacity: 1;
}

.confirm-cancellation {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.confirm-cancellation .modal-input_cancel,
.confirm-cancellation .modal-bottom {
  margin: 0;
}

.application-for-new-service .modal-input_cancel {
  margin-top: 32px;
}

.input,
.textarea {
  border-radius: 8px;
  border: 1px solid #e8ecee;
  background: #fff;
  padding: 3px 10px;
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: 0.2s ease-in-out;
  transition-property: border, background, color;
}
.input::placeholder,
.textarea::placeholder {
  color: #7A808B;
}
.input[disabled],
.textarea[disabled] {
  background: #f5f5f5;
}
@media (min-width: 640px) {
  .input,
  .textarea {
    font-size: 20px;
    padding-left: 32px;
    height: 64px;
    letter-spacing: -0.4px;
  }
}
@media (min-width: 1200px) {
  .input,
  .textarea {
    font-size: var(--fz-md);
    height: 38px;
    letter-spacing: normal;
    padding-left: 10px;
  }
}
.input.error,
.textarea.error {
  border-color: #f2200d;
}

.textarea {
  height: 88px;
  padding-top: 7px;
  padding-bottom: 7px;
  resize: none;
}
@media (min-width: 640px) {
  .textarea {
    padding-top: 19px;
    padding-bottom: 19px;
  }
}
@media (min-width: 1200px) {
  .textarea {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.modal-bottom {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  grid-gap: 12px;
}
@media (min-width: 1200px) {
  .modal-bottom {
    margin-top: 24px;
  }
}
.modal-bottom .btn_sm {
  width: 94px;
  min-width: 94px;
}

.modal-bottom-signature {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.22px;
  margin-top: 8px;
}
.modal-bottom-signature img {
  margin-left: 6px;
  max-width: 30px;
  filter: grayscale(1);
}

.error-text {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  color: var(--error);
  font-size: var(--fz-md);
  font-style: normal;
  font-weight: 600;
  line-height: var(--lh-md);
  transition: 0.15s;
}

.overscroll-behavior {
  overscroll-behavior-y: none;
}
.overscroll-behavior * {
  overflow-y: hidden;
}

/* Custom scrollbar */
.ScrollbarsCustom {
  width: 100%;
  height: 100%;
}
.ScrollbarsCustom--full-height .ScrollbarsCustom-TrackY {
  top: 0;
  height: 100%;
}

.ScrollbarsCustom-Scroller {
  padding-right: 17px !important;
  margin-right: -17px !important;
}
.ScrollbarsCustom-Scroller::-webkit-scrollbar {
  width: 0;
}

.ScrollbarsCustom-Wrapper {
  inset: 0 10px 0 0;
}

.ScrollbarsCustom-Track {
  width: 4px;
  background: #f0f6ff;
  border-radius: 2px;
  height: calc(100% - 20px);
  position: absolute;
  overflow: hidden;
  transition: 0.5s;
  opacity: 0;
}
@supports (font: -apple-system-body) and (-webkit-appearance: none) {
  .ScrollbarsCustom-Track {
    width: 4px !important;
  }
}
.ScrollbarsCustom-Track:hover, .ScrollbarsCustom-Track.visible {
  opacity: 1;
}

.ScrollbarsCustom-TrackY {
  top: 10px;
  right: 0;
}

.ScrollbarsCustom-TrackX {
  left: 0;
  bottom: 0;
  height: 8px;
  width: calc(100% - 10px);
}

.ScrollbarsCustom-Thumb {
  border-radius: 8px;
  background: #c9c9c9;
  cursor: pointer;
  width: 100%;
  height: 100%;
  transition: opacity 0.2s;
}
.ScrollbarsCustom-Thumb:hover {
  opacity: 0.8;
}

@-moz-document url-prefix() {
  * {
    scrollbar-width: thin;
    /* "auto" или "thin"  */
  }
}

*::-webkit-scrollbar {
  width: 4px;
  /* ширина для вертикального скролла */
  height: 4px;
  /* высота для горизонтального скролла */
  cursor: pointer;
}

*::-webkit-scrollbar-track {
  background: none;
  /* цвет дорожки */
}

/* ползунок скроллбара */
*::-webkit-scrollbar-thumb {
  background-color: #c9c9c9;
  /* цвет плашки */
  border-radius: 8px;
  /* закругления плашки */
}
@media (hover: hover) {
  *::-webkit-scrollbar-thumb:hover {
    background-color: #a6a2a2;
  }
}

/* END Custom scrollbar */
.image-gallery {
  width: 100%;
}
.image-gallery-content .fullscreen {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.order-info-callback-modal {
  padding: 12px;
  align-items: flex-end;
}
.order-info-callback-modal .modal__header {
  border: none;
  padding-bottom: 0;
  min-height: auto;
}
.order-info-callback-modal .modal__header .modal__title {
  font-size: 22px;
}
.order-info-callback-modal .modal__body p {
  font-size: 16px;
  line-height: 144%;
}

.layout__footer-padding {
  padding-bottom: 140px;
}

.order-id-layout__main {
  position: initial !important;
}

#globalTooltip.react-tooltip {
  padding: 4px 8px;
  margin: 10px 0;
  border-radius: 2px;
  background: rgba(22, 34, 54, 0.8);
  color: #f7faff;
  line-height: 1.4em;
  overflow: hidden;
}
#globalTooltip.react-tooltip .react-tooltip-arrow {
  display: none;
}

#html5qr-code-full-region {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/scafolding.scss","webpack://./src/styles/skeletons.scss","webpack://./src/styles/custom-select.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACWd;EACE,gCAYU;EAXV,kBAW+B;EAV/B,gBAUuC;EATvC,8RAAA;EAKA,kBAAA;ADZJ;ACGE;EACE,gCAaU;EAZV,kBAY+B;EAX/B,gBAWuC;EAVvC,8RAAA;EAKA,kBAAA;ADLJ;ACJE;EACE,gCAcU;EAbV,kBAa+B;EAZ/B,gBAYuC;EAXvC,mSAAA;EAKA,kBAAA;ADEJ;ACXE;EACE,gCAeU;EAdV,kBAc+B;EAb/B,gBAauC;EAZvC,mSAAA;EAKA,kBAAA;ADSJ;AE1BA;EACE,mCAAA;EAEA,uBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EAGA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EAGA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EAIA,aAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EAEA,aAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EAEA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EAEA,uBAAA;AFiBF;;AEdA;EACE;IACE,qBAAA;EFiBF;AACF;AGvFE;;EACE,aAAA;AH0FJ;;AGtFA;EACE,sBAAA;EACA,wCAAA;AHyFF;;AGjFA;;EAEE,mBAAA;AHoFF;;AGjFA;EACE,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;AHoFF;;AGjFA;EACG,kBAAA;AHoFH;AGlFE;EACE,UAAA;EACA,oBAAA;AHoFJ;AGjFE;EAEE,oBAAA;AHkFJ;AG/EE;EACE,gBAAA;AHiFJ;;AG5EA;;;;;;EAME,mBAAA;EACA,SAAA;EACA,UAAA;AH+EF;;AG5EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AH+EF;;AG5EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AH+EF;;AG5EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AH+EF;;AG5EA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AH+EF;;AG5EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AH+EF;;AG5EA;EACE,cAAA;AH+EF;;AG5EA;EACE,UAAA;EACA,SAAA;AH+EF;;AG5EA;EACE,kBAAA;EACA,kBAAA;AH+EF;;AG5EA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AH+EF;;AG5EA;;EAEE,oBAAA;EACA,YAAA;EACA,aAAA;AH+EF;;AIrMA;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qGAAA;EACA,qDAAA;AJyMF;;AItMA;;EAEE,mBAAA;EACA,gBAAA;EACA,kBAAA;AJyMF;AInMA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AJqMF;AI/LE;EACE,WAAA;AJiMJ;;AI7LA;EACE,+BAAA;EACA,gBAAA;AJgMF;AI9LE;EACE,kBAAA;EACA,UAAA;AJgMJ;AI7LE;EAEE,UAAA;AJ8LJ;;AI1LA;EACE;IACE,mCAAA;EJ6LF;EI1LA;IACE,kCAAA;EJ4LF;AACF;AKzPI;EACE,eAAA;EACA,gBAAA;AL2PN;AKzPM;EAEE,iCAAA;AL0PR;AKtPI;EACE,cAAA;EACA,iBAAA;ALwPN;AKrPI;EACE,eAAA;ALuPN;AKrPM;EAEE,oDAAA;ALsPR;AKnPM;EACE,qCAAA;EACA,+BAAA;ALqPR;AKnPQ;EACE,qCAAA;EACA,+BAAA;ALqPV;;AAzQA;EACE,mBAAA;EACA,wBAAA;AA4QF;;AAzQA;EACE,aAAA;AA4QF;;AAzQA;;EAEE,UAAA;EACA,SAAA;EACA,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;AA4QF;AA1QE;EAbF;;IAcI,mBAAA;EA8QF;AACF;AA5QE;;EACE,gBAAA;AA+QJ;;AA3QA;EACE,cAAA;EACA,qBAAA;AA8QF;;AAjQA;EAGE,iBAAA;EACA,6BAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AAkQF;AAhQE;EAXF;IAYI,uBAAA;EAmQF;AACF;AAjQE;EAfF;IAgBI,iBAAA;IACA,UAAA;EAoQF;AACF;AAlQE;;EAEE,cAAA;AAoQJ;AAjQE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAmQJ;AAjQI;EALF;IAMI,oBAAA;EAoQJ;AACF;;AAhQA;;;EAGE,WAAA;EACA,gBAAA;AAmQF;AAjQE;EANF;;;IAOI,eAAA;EAsQF;AACF;;AAnQA;;EAEE,cAAA;AAsQF;;AAlQE;EADF;IAEI,aAAA;IACA,gBAAA;IACA,2BAAA;IACA,iCAAA;EAsQF;AACF;;AAlQE;EADF;IAEI,cAAA;IACA,yBAAA;EAsQF;AACF;AApQE;EACE,gBAAA;EACA,sCAAA;EACA,cAAA;AAsQJ;;AA/PM;EADF;IAEI,4BAAA;EAmQN;AACF;AA/PM;EADF;IAEI,oDAAA;EAkQN;AACF;;AA7PA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAgQF;AA9PE;EALF;IAMI,cAAA;IACA,SAAA;IACA,iDAAA;EAiQF;AACF;AA9PI;EADF;IAEI,eAAA;EAiQJ;AACF;;AA7PA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;AAgQF;AA9PE;EALF;IAMI,mBAAA;EAiQF;AACF;;AA9PA;EACE,aAAA;EACA,qBAAA;AAiQF;AA/PE;EACE,gBAAA;EACA,eAAA;AAiQJ;AA/PI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAiQN;AA9PI;EACE,iBAAA;AAgQN;AA7PI;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA+PN;AA5PI;EACE,SAAA;EACA,WAAA;AA8PN;;AAzPA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AA4PF;AA1PE;EALF;IAMI,iBAAA;EA6PF;AACF;;AA1PA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,4DAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA6PF;AA3PE;EACE,YAAA;EACA,eAAA;AA6PJ;AA1PE;EACE,gBAAA;EACA,WAAA;AA4PJ;AAzPE;EACE,4DAAA;AA2PJ;AAxPE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,oCAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;AA0PJ;AAvPE;EACE;IACE,wCAAA;EAyPJ;EAtPE;IACE,0CAAA;EAwPJ;EArPE;IACE,wCAAA;EAuPJ;AACF;AApPE;EACE;IACE,YAAA;EAsPJ;AACF;AAnPE;EA9DF;IA+DI,eAAA;IACA,YAAA;EAsPF;AACF;;AAnPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAsPF;;AAnPA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAsPF;AApPE;EAPF;IAQI,eAAA;IACA,iBAAA;EAuPF;AACF;AArPE;EAZF;IAaI,eAAA;IACA,iBAAA;IACA,gBAAA;EAwPF;AACF;;AArPA;EACE,eAAA;EACA,uBAAA;EACA,iBAAA;AAwPF;AAtPE;EALF;IAMI,sBAAA;IACA,eAAA;EAyPF;AACF;AAvPE;EAVF;IAWI,uBAAA;IACA,yBAAA;IACA,sBAAA;IACA,kBAAA;EA0PF;AACF;AAxPE;EACE,cAAA;EACA,0BAAA;AA0PJ;;AAtPA;EACE,gBAAA;AAyPF;AAvPE;EAHF;IAII,gBAAA;EA0PF;AACF;AAxPE;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;AA0PJ;AAxPI;EALF;IAMI,sBAAA;IACA,yBAAA;EA2PJ;AACF;AAxPE;;EAEE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA0PJ;AAxPI;;EACE,mBAAA;AA2PN;AAvPE;EACE,cAAA;AAyPJ;AAtPE;EACE,gBAAA;AAwPJ;AAtPI;;EAEE,eAAA;EACA,gBAAA;AAwPN;AAnPI;EACE,qBAAA;AAqPN;AAlPI;EACE,UAAA;AAoPN;;AA/OA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAkPF;AAhPE;;EAEE,SAAA;AAkPJ;;AA7OE;EACE,gBAAA;AAgPJ;;AA5OA;;EAEE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,8CAAA;AA+OF;AA7OE;;EACE,cAAA;AAgPJ;AA7OE;;EACE,mBAAA;AAgPJ;AA7OE;EAvBF;;IAwBI,eAAA;IACA,kBAAA;IACA,YAAA;IACA,sBAAA;EAiPF;AACF;AA/OE;EA9BF;;IA+BI,uBAAA;IACA,YAAA;IACA,sBAAA;IACA,kBAAA;EAmPF;AACF;AAjPE;;EACE,qBAAA;AAoPJ;;AAhPA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAmPF;AAjPE;EANF;IAOI,iBAAA;IACA,oBAAA;EAoPF;AACF;AAlPE;EAXF;IAYI,iBAAA;IACA,oBAAA;EAqPF;AACF;;AAlPA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAqPF;AAnPE;EANF;IAOI,gBAAA;EAsPF;AACF;AApPE;EACE,WAAA;EACA,eAAA;AAsPJ;;AAlPA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;AAqPF;AAnPE;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;AAqPJ;;AAjPA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAoPF;;AAhPA;EACE,2BAAA;AAmPF;AAjPE;EACE,kBAAA;AAmPJ;;AA/OA,qBAAA;AAEA;EACE,WAAA;EACA,YAAA;AAiPF;AA9OI;EACE,MAAA;EACA,YAAA;AAgPN;;AA3OA;EACE,8BAAA;EACA,8BAAA;AA8OF;AA5OE;EACE,QAAA;AA8OJ;;AA1OA;EACE,iBAAA;AA6OF;;AA1OA;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AA6OF;AA3OE;EAVF;IAWI,qBAAA;EA8OF;AACF;AA5OE;EAEE,UAAA;AA6OJ;;AAzOA;EACE,SAAA;EACA,QAAA;AA4OF;;AAzOA;EACE,OAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;AA4OF;;AAzOA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AA4OF;AA1OE;EACE,YAAA;AA4OJ;;AAvOE;EADF;IAEI,qBAAA;IACA,uBAAA;EA2OF;AACF;;AAvOA;EACE,UAAA;EACA,qCAAA;EACA,WAAA;EACA,uCAAA;EAEA,eAAA;AAyOF;;AAtOA;EACE,gBAAA;EACA,iBAAA;AAyOF;;AAtOA,wBAAA;AACA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAyOF;AAtOE;EACE;IACE,yBAAA;EAwOJ;AACF;;AApOA,yBAAA;AAEA;EACE,WAAA;AAsOF;AAnOI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAqON;;AAhOA;EACE,aAAA;EACA,qBAAA;AAmOF;AAjOE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AAmOJ;AAjOI;EACE,eAAA;AAmON;AA9NI;EACE,eAAA;EACA,iBAAA;AAgON;;AA3NA;EACE,qBAAA;AA8NF;;AA3NA;EACE,4BAAA;AA8NF;;AA3NA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA8NF;AA5NE;EACE,aAAA;AA8NJ;;AA1NA;EACE,WAAA;AA6NF","sourcesContent":["@import \"breakpoints\";\n@import \"fonts\";\n@import \"variables\";\n@import \"scafolding\";\n@import \"skeletons\";\n//@import \"swiper/css\";\n//@import \"swiper/css/pagination\";\n@import \"react-datepicker/dist/react-datepicker.css\";\n// @import 'custom-datepicker';\n@import \"custom-select\";\n\n:root {\n  --app-height: 100vh;\n  --app-height-dvh: 100dvh;\n}\n\nbody>iframe {\n  display: none;\n}\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: var(--default-font), sans-serif;\n  font-size: 14px;\n  line-height: 100%;\n  font-weight: 400;\n  color: var(--text-color);\n  scroll-behavior: smooth;\n  background: #fafafa;\n  --webkit-font-smoothing: antialiased;\n\n  @media (min-width: 1200px) {\n    background: #F6F7F8;\n  }\n\n  &.noscroll {\n    overflow: hidden;\n  }\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n// @media (prefers-color-scheme: dark) {\n//   html {\n//     color-scheme: dark;\n//   }\n//   body {\n//     color: white;\n//     background: black;\n//   }\n// }\n\n.wrapper {\n  // overflow-x: hidden;\n  //overflow-y: hidden;\n  min-height: 100vh;\n  min-height: var(--app-height);\n  min-height: var(--app-height-dvh);\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  width: 100%;\n\n  @media (min-width: 640px) {\n    padding: 36px 24px 20px;\n  }\n\n  @media (min-width: 1200px) {\n    overflow: initial;\n    padding: 0;\n  }\n\n  .header,\n  .footer {\n    flex: 0 0 auto;\n  }\n\n  main {\n    display: flex;\n    position: relative;\n    flex: 1 0 auto;\n\n    @media (max-width: 1200px) {\n      padding-bottom: 62px;\n    }\n  }\n}\n\n.header,\n.footer,\nmain {\n  width: 100%;\n  max-width: 800px;\n\n  @media (min-width: 1200px) {\n    max-width: none;\n  }\n}\n\n.header,\nmain {\n  margin: 0 auto;\n}\n\nmain {\n  @media (min-width: 1200px) {\n    display: flex;\n    grid-gap: 0 40px;\n    max-width: var(--container);\n    padding: 25px var(--grid-spacing);\n  }\n}\n\n.main-aside {\n  @media (min-width: 1200px) {\n    flex-shrink: 0;\n    width: var(--aside-width);\n  }\n\n  &__inner {\n    position: sticky;\n    top: calc(var(--header-height) + 25px);\n    width: inherit;\n  }\n}\n\n.main {\n  &--md {\n    .main-aside {\n      @media (min-width: 1200px) {\n        width: var(--aside-width-md);\n      }\n    }\n\n    .main-content {\n      @media (min-width: 1200px) {\n        max-width: calc(100% - var(--aside-width-md) - 40px);\n      }\n    }\n  }\n}\n\n.main-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  @media (min-width: 1200px) {\n    display: block;\n    flex: 1;\n    max-width: calc(100% - var(--aside-width) - 40px);\n  }\n\n  &--full {\n    @media (min-width: 1200px) {\n      max-width: none;\n    }\n  }\n}\n\n.footer {\n  position: relative;\n  z-index: 2;\n  margin: auto auto 66px;\n\n  @media (min-width: 1200px) {\n    margin: auto auto 0;\n  }\n}\n\n.lang-modal {\n  padding: 12px;\n  align-items: flex-end;\n\n  .modal__inner {\n    margin-bottom: 0;\n    max-width: none;\n\n    .modal-head {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n\n    .modal-title {\n      line-height: 25px;\n    }\n\n    .modal-desc {\n      font-size: 12px;\n      line-height: 13.5px;\n      color: #7A808B;\n    }\n\n    .modal__close-btn {\n      top: 16px;\n      right: 16px;\n    }\n  }\n}\n\n.container {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n\n  @media (min-width: 1200px) {\n    max-width: 1440px;\n  }\n}\n\n.btn {\n  height: 44px;\n  width: 100%;\n  border-radius: 12px;\n  background: linear-gradient(90deg, #457cfa 0%, #984cf4 100%);\n  transition: 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  color: #fff;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  position: relative;\n\n  &:disabled {\n    opacity: 0.8;\n    cursor: default;\n  }\n\n  &_grey {\n    background: #eee;\n    color: #000;\n  }\n\n  &_orange {\n    background: linear-gradient(90deg, #fa7b45 0%, #f44c4c 100%);\n  }\n\n  &-loader {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 10px;\n    animation: loader 2s infinite linear;\n    transform-origin: center;\n    width: 24px;\n    height: 24px;\n  }\n\n  @keyframes loader {\n    0% {\n      transform: translateY(-50%) rotate(0deg);\n    }\n\n    0% {\n      transform: translateY(-50%) rotate(360deg);\n    }\n\n    100% {\n      transform: translateY(-50%) rotate(0deg);\n    }\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  @media (min-width: 640px) {\n    font-size: 20px;\n    height: 76px;\n  }\n}\n\n.modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modal-title {\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n  color: #000;\n\n  @media (min-width: 640px) {\n    font-size: 32px;\n    line-height: 42px;\n  }\n\n  @media (min-width: 1200px) {\n    font-size: 24px;\n    line-height: 27px;\n    font-weight: 500;\n  }\n}\n\n.modal-text {\n  margin-top: 8px;\n  letter-spacing: -0.28px;\n  line-height: 144%;\n\n  @media (min-width: 640px) {\n    letter-spacing: -0.4px;\n    font-size: 20px;\n  }\n\n  @media (min-width: 1200px) {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n    letter-spacing: normal;\n    text-align: center;\n  }\n\n  &__link {\n    color: #1d8ae2;\n    text-decoration: underline;\n  }\n}\n\n.modal-input {\n  margin-top: 32px;\n\n  @media (min-width: 1200px) {\n    margin-top: 24px;\n  }\n\n  .input-label {\n    line-height: 144%;\n    letter-spacing: -0.28px;\n    margin-bottom: 8px;\n\n    @media (min-width: 1200px) {\n      letter-spacing: normal;\n      line-height: var(--lh-md);\n    }\n  }\n\n  input,\n  textarea {\n    border-radius: 12px;\n    border: 1px solid #e8ecee;\n    background: #fff;\n    padding: 13px 16px;\n    height: 52px;\n    width: 100%;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    resize: none;\n\n    &[disabled] {\n      background: #f5f5f5;\n    }\n  }\n\n  textarea {\n    overflow: auto;\n  }\n\n  &_cancel {\n    margin-top: 16px;\n\n    input,\n    textarea {\n      font-size: 16px;\n      font-weight: 400;\n    }\n  }\n\n  &.error {\n    input {\n      border-color: #f2200d;\n    }\n\n    .error-text {\n      opacity: 1;\n    }\n  }\n}\n\n.confirm-cancellation {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .modal-input_cancel,\n  .modal-bottom {\n    margin: 0;\n  }\n}\n\n.application-for-new-service {\n  .modal-input_cancel {\n    margin-top: 32px;\n  }\n}\n\n.input,\n.textarea {\n  border-radius: 8px;\n  border: 1px solid #e8ecee;\n  background: #fff;\n  padding: 3px 10px;\n  height: 40px;\n  width: 100%;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  transition: 0.2s ease-in-out;\n  transition-property: border, background, color;\n\n  &::placeholder {\n    color: #7A808B;\n  }\n\n  &[disabled] {\n    background: #f5f5f5;\n  }\n\n  @media (min-width: 640px) {\n    font-size: 20px;\n    padding-left: 32px;\n    height: 64px;\n    letter-spacing: -0.4px;\n  }\n\n  @media (min-width: 1200px) {\n    font-size: var(--fz-md);\n    height: 38px;\n    letter-spacing: normal;\n    padding-left: 10px;\n  }\n\n  &.error {\n    border-color: #f2200d;\n  }\n}\n\n.textarea {\n  height: 88px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  resize: none;\n\n  @media (min-width: 640px) {\n    padding-top: 19px;\n    padding-bottom: 19px;\n  }\n\n  @media (min-width: 1200px) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n}\n\n.modal-bottom {\n  margin-top: 32px;\n  display: flex;\n  justify-content: space-between;\n  grid-gap: 12px;\n\n  @media (min-width: 1200px) {\n    margin-top: 24px;\n  }\n\n  .btn_sm {\n    width: 94px;\n    min-width: 94px;\n  }\n}\n\n.modal-bottom-signature {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: -0.22px;\n  margin-top: 8px;\n\n  img {\n    margin-left: 6px;\n    max-width: 30px;\n    filter: grayscale(1);\n  }\n}\n\n.error-text {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n  color: var(--error);\n  font-size: var(--fz-md);\n  font-style: normal;\n  font-weight: 600;\n  line-height: var(--lh-md);\n  transition: 0.15s;\n\n}\n\n.overscroll-behavior {\n  overscroll-behavior-y: none;\n\n  * {\n    overflow-y: hidden;\n  }\n}\n\n/* Custom scrollbar */\n\n.ScrollbarsCustom {\n  width: 100%;\n  height: 100%;\n\n  &--full-height {\n    .ScrollbarsCustom-TrackY {\n      top: 0;\n      height: 100%;\n    }\n  }\n}\n\n.ScrollbarsCustom-Scroller {\n  padding-right: 17px !important;\n  margin-right: -17px !important;\n\n  &::-webkit-scrollbar {\n    width: 0;\n  }\n}\n\n.ScrollbarsCustom-Wrapper {\n  inset: 0 10px 0 0;\n}\n\n.ScrollbarsCustom-Track {\n  width: 4px;\n  background: #f0f6ff;\n  border-radius: 2px;\n  height: calc(100% - 20px);\n  position: absolute;\n  overflow: hidden;\n  transition: 0.5s;\n  opacity: 0;\n\n  @supports (font: -apple-system-body) and (-webkit-appearance: none) {\n    width: 4px !important;\n  }\n\n  &:hover,\n  &.visible {\n    opacity: 1;\n  }\n}\n\n.ScrollbarsCustom-TrackY {\n  top: 10px;\n  right: 0;\n}\n\n.ScrollbarsCustom-TrackX {\n  left: 0;\n  bottom: 0;\n  height: 8px;\n  width: calc(100% - 10px);\n}\n\n.ScrollbarsCustom-Thumb {\n  border-radius: 8px;\n  background: #c9c9c9;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n* {\n  @-moz-document url-prefix() {\n    scrollbar-width: thin;\n    /* \"auto\" или \"thin\"  */\n    //scrollbar-color: blue orange; /* плашка скролла и дорожка */\n  }\n}\n\n*::-webkit-scrollbar {\n  width: 4px;\n  /* ширина для вертикального скролла */\n  height: 4px;\n  /* высота для горизонтального скролла */\n  //background-color: #F0F6FF;\n  cursor: pointer;\n}\n\n*::-webkit-scrollbar-track {\n  background: none;\n  /* цвет дорожки */\n}\n\n/* ползунок скроллбара */\n*::-webkit-scrollbar-thumb {\n  background-color: #c9c9c9;\n  /* цвет плашки */\n  border-radius: 8px;\n  /* закругления плашки */\n  //border: 3px solid orange;  /* padding вокруг плашки */\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: #a6a2a2;\n    }\n  }\n}\n\n/* END Custom scrollbar */\n\n.image-gallery {\n  width: 100%;\n\n  &-content {\n    .fullscreen {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n\n.order-info-callback-modal {\n  padding: 12px;\n  align-items: flex-end;\n\n  .modal__header {\n    border: none;\n    padding-bottom: 0;\n    min-height: auto;\n\n    .modal__title {\n      font-size: 22px;\n    }\n  }\n\n  .modal__body {\n    p {\n      font-size: 16px;\n      line-height: 144%;\n    }\n  }\n}\n\n.layout__footer-padding {\n  padding-bottom: 140px;\n}\n\n.order-id-layout__main {\n  position: initial !important;\n}\n\n#globalTooltip.react-tooltip {\n  padding: 4px 8px;\n  margin: 10px 0;\n  border-radius: 2px;\n  background: rgba(22, 34, 54, 0.8);\n  color: #f7faff;\n  line-height: 1.4em;\n  overflow: hidden;\n\n  & .react-tooltip-arrow {\n    display: none;\n  }\n}\n\n#html5qr-code-full-region {\n  width: 100%;\n}","@mixin fontRuble($f-name, $f-style, $f-weight, $f-url) {\n  @font-face {\n    font-family: $f-name;\n    font-style: $f-style;\n    font-weight: $f-weight;\n    src: url('/fonts/#{$f-url}.ttf') format('truetype');\n    font-display: swap;\n  }\n}\n\n@mixin font($f-name, $f-style, $f-weight, $f-url) {\n  @font-face {\n    font-family: $f-name;\n    font-style: $f-style;\n    font-weight: $f-weight;\n    src: url('/fonts/#{$f-url}.woff2') format('woff2'),\n      url('/fonts/#{$f-url}.woff') format('woff'),\n      url('/fonts/#{$f-url}.ttf') format('truetype'),\n      url('/fonts/#{$f-url}.eot'),\n      url('/fonts/#{$f-url}.eot?#iefix') format('embedded-opentype');\n    font-display: swap;\n  }\n}\n\n@include font('Euclid Circular B', normal, 400, 'EuclidCircularB/EuclidCircularB-Regular');\n@include font('Euclid Circular B', normal, 500, 'EuclidCircularB/EuclidCircularB-Medium');\n@include font('Euclid Circular B', normal, 600, 'EuclidCircularB/EuclidCircularB-SemiBold');\n@include font('Euclid Circular B', normal, 700, 'EuclidCircularB/EuclidCircularB-Bold');\n","@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n:root {\n  --default-font: 'Euclid Circular B';\n  // project settings\n  --accent-color: #2DBE64;\n  --accent-color-rgb: 45, 190, 100;\n  --accent-text-color: #fff;\n  --text-color: #151B26;\n\n  //colors\n  --white: #ffffff;\n  --white-550: #F2F2F2;\n  --gray-20: #F0F1F5;\n  --grey-25: #F9FAFB;\n  --gray-100: #E0E7EB;\n  --gray-200: #C2CFD6;\n  --gray-180: #47536B;\n  --gray-500: #668899;\n  --gray-950: #101618;\n  --error: #fa5959;\n  --orange-500: #F2A60F;\n\n  //TODO: old, remove\n  --black: #101010;\n  --black-900: #000000;\n  --background: #F4F5FF;\n  --grey-50: #FCFCFC;\n  --grey-90: #F9F9F9;\n  --grey-250: #E8EBF0;\n  --grey-300: #D2D2D2;\n  --blue: #6420FF;\n  --blue-300: #5c8cdf;\n  --blue-500: #177FD2;\n  --red: #FF6864;\n  --green-300: #B6DF73;\n  --green: #7CBA00;\n  --yellow: #FFB803;\n  --violet: #A700FF;\n  --overlay-color: #00000099;\n  //grad - blue + violet\n\n  //sizes\n  --fz-xs: 10px;\n  --fz-sm: 12px;\n  --fz-md: 14px;\n  --fz-lg: 16px;\n\n  --lh-xs: 12px;\n  --lh-sm: 14px;\n  --lh-md: 16px;\n  --lh-lg: 18px;\n  --lh-xlg: 20px;\n\n  --header-height: 48px;\n  --grid-spacing: 24px;\n  --container: 1208px;\n  --aside-width: 260px;\n  --aside-width-md: 320px;\n  --modal-aside-width: 260px;\n  --modal-aside-width-lg: 360px;\n  --modal-chats-body-width: 520px;\n  --modal-chats-info-width: 224px;\n  --modal-footer-height: 48px;\n\n  --transition: 0.2s ease;\n}\n\n@media (min-width: 640px) {\n  :root {\n    --header-height: 64px;\n  }\n}\n","[data-whatintent='touch'],\n[data-whatintent='mouse'] {\n  *:focus {\n    outline: none;\n  }\n}\n\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  // @include scrollbar();\n\n  // &:focus-visible {\n  //   outline: 2px solid darkviolet;\n  // }\n}\n\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nbutton {\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n\nsvg {\n   fill: currentColor;\n\n  &.stroke-icon {\n    fill: none;\n    stroke: currentColor;\n  }\n\n  a &,\n  button & {\n    pointer-events: none; // Мы любим Edge, это браузер! (почти)\n  }\n\n  &:not(:root) {\n    overflow: hidden; // Скрыть выступающее за границы в IE\n  }\n}\n\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: currentColor;\n  margin: 0;\n  padding: 0;\n}\n\nh2 {\n  font-size: 24px;\n  line-height: 28px;\n  font-weight: 500;\n}\n\nh3 {\n  font-size: 20px;\n  line-height: 23px;\n  font-weight: 500;\n}\n\nh4 {\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: 500;\n}\n\nh5 {\n  font-size: 14px;\n  line-height: normal;\n  font-weight: 600;\n}\n\nh6 {\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 500;\n}\n\nhr {\n  margin: 10px 0;\n}\n\nul, p {\n  padding: 0;\n  margin: 0;\n}\n\nblockquote {\n  font-style: italic;\n  margin: 0 0 0 20px;\n}\n\nfieldset {\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n}\n\ninput,\ntextarea {\n  font-family: inherit;\n  border: none;\n  outline: none;\n}\n","\n%afterSkeleton {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(56.25% 434.37% at 53.12% 53.13%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);\n  animation: skeletonProgress 1.2s ease-in-out infinite;\n}\n\n.selectBack,\n.skeletonBlock {\n  background: #EAEAEA;\n  overflow: hidden;\n  position: relative;\n  &::after {\n    @extend %afterSkeleton;\n  }\n}\n\n.selectSkeleton {\n  min-height: 40px;\n  cursor: pointer;\n  background: #EAEAEA;\n  border-radius: 8px 0 0 8px;\n  box-shadow: none;\n  width: 130px;\n  overflow: hidden;\n  position: relative;\n\n  &::after {\n    @extend %afterSkeleton;\n  }\n\n  &_bottom {\n    width: 28px;\n  }\n}\n\n.skeletonImage {\n  background: var(--color-border);\n  overflow: hidden;\n\n  & * {\n    position: relative;\n    z-index: 2;\n  }\n\n  &::after {\n    @extend %afterSkeleton;\n    z-index: 1;\n  }\n}\n\n@keyframes skeletonProgress {\n  0% {\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  100% {\n    transform: translate3d(100%, 0, 0);\n  }\n}  ",".custom-select {\r\n  .custom-select {\r\n    &__control {\r\n      cursor: pointer;\r\n      box-shadow: none;\r\n\r\n      &--is-focused,\r\n      &:hover {\r\n        border-color: var(--accent-color);\r\n      }\r\n    }\r\n\r\n    &__menu-list {\r\n      padding-top: 0;\r\n      padding-bottom: 0;\r\n    }\r\n\r\n    &__option {\r\n      cursor: pointer;\r\n\r\n      &:active,\r\n      &--is-focused {\r\n        background-color: rgba(var(--accent-color-rgb), 0.1);\r\n      }\r\n\r\n      &--is-selected {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n\r\n        &:active {\r\n          background-color: var(--accent-color);\r\n          color: var(--accent-text-color);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
